module.exports = __webpack_public_path__ + "img/order7.f8d1d9e4.svg";